

export function EcoleBranding({ darkMode = true, isEditable = false, onSave }) {
  return (
    <div className="space-y-8">
      <div className="border-b border-zinc-800 pb-4">
        <h3 className="text-2xl font-black tracking-tighter text-purple-400">
          IDENTITÉ VISUELLE & SÉMANTIQUE
        </h3>
        <p className="text-[11px] uppercase tracking-widest text-zinc-500 mt-1">
          Contrôle des éléments graphiques et narratifs de la Grande École
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="border border-zinc-800 p-6 bg-black/40">
          <h4 className="text-lg font-black text-purple-300 mb-4">Palette Principale</h4>
          <div className="grid grid-cols-5 gap-2">
            <div className="h-20 bg-red-600 rounded-sm flex items-center justify-center text-xs font-mono">RED</div>
            <div className="h-20 bg-orange-500 rounded-sm flex items-center justify-center text-xs font-mono">ORANGE</div>
            <div className="h-20 bg-amber-400 rounded-sm flex items-center justify-center text-xs font-mono">AMBER</div>
            <div className="h-20 bg-emerald-500 rounded-sm flex items-center justify-center text-xs font-mono">EMERALD</div>
            <div className="h-20 bg-sky-500 rounded-sm flex items-center justify-center text-xs font-mono">SKY</div>
          </div>
        </div>

        <div className="border border-zinc-800 p-6 bg-black/40">
          <h4 className="text-lg font-black text-purple-300 mb-4">Logo & Baseline</h4>
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <div className="w-24 h-24 bg-purple-900/30 rounded-none flex items-center justify-center text-purple-400 font-black text-4xl border border-purple-500/30">
                GE
              </div>
              <div>
                <input
                  defaultValue="Grande École"
                  className="w-full bg-transparent border-b border-zinc-700 text-xl font-black outline-none"
                />
                <input
                  defaultValue="Au service de l'Intelligence Humaine"
                  className="w-full bg-transparent border-b border-zinc-700 text-sm text-zinc-400 outline-none mt-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border border-zinc-800 p-6 bg-black/40">
        <h4 className="text-lg font-black text-purple-300 mb-4">Typographie & Ton Narratif</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="text-[11px] uppercase text-zinc-500 mb-2 block">Police Principale</label>
            <select className="w-full bg-zinc-900 border border-zinc-700 p-3 text-sm font-mono outline-none">
              <option>JetBrains Mono</option>
              <option>Fira Code</option>
              <option>IBM Plex Mono</option>
            </select>
          </div>
          <div>
            <label className="text-[11px] uppercase text-zinc-500 mb-2 block">Ton Général</label>
            <select className="w-full bg-zinc-900 border border-zinc-700 p-3 text-sm font-mono outline-none">
              <option>Direct – Exigeant – Radical</option>
              <option>Empathique – Soutenant</option>
              <option>Technique – Neutre</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}